import {
    ADDUPDATEKYCCONF_SUCCESS,
    ADDUPDATEKYCCONF_FAILED,
    RESET_ADDUPDATEKYCCONF,
    LOADING_ADDUPDATEKYCCONF,
    NETWORK_ERROR_ADDUPDATEKYCCONF
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDUPDATEKYCCONF:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDUPDATEKYCCONF_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDUPDATEKYCCONF_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDUPDATEKYCCONF:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDUPDATEKYCCONF:
            return (state = initialState);
        default:
            return state;
    }
};
